export default (theme: any) => ({
    small: {
        width: theme.spacing(2.5),
        height: theme.spacing(2.5),
    },

    tintColorBlue: {
        filter: 'invert(42%) sepia(99%) saturate(2408%) hue-rotate(207deg) brightness(93%) contrast(101%)',
    },

    tintColorGray: {
        filter: 'invert(58%) sepia(2%) saturate(2862%) hue-rotate(195deg) brightness(89%) contrast(82%)',
    },

    buttonContainer: {
        minWidth: 0,
        minHeight: 0,
    },
})
